export default __webpack_public_path__ + "static/es-bc588dbdff90518e8741ab494dc1c64b.svg";